"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var size_1 = require("./size");
exports.Size = size_1.default;
var color_1 = require("./color");
exports.Color = color_1.default;
//# sourceMappingURL=index.js.map